import BulkUploadDriverReservation from "../../../views/BulkUploadDriverReservation";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const bulkUploadDriverReservationRoutes = [
  {
    menuName: MenuNames.DRIVER_RESERVATION,
    path: "/bulk-upload-driver-reservation",
    component: BulkUploadDriverReservation,
    exact: true,
  },
];

export default bulkUploadDriverReservationRoutes;
